import { apiFuns } from "sw-hic";
let { get, post, put, del, genStandard } = apiFuns;
let api = {
  Menus: {
    ...genStandard("menus", "/api/md"),
    getMyMenus: (para) => {
      return post(`/api/md/menus/meMenus`, para);
    },
    copy: (clientId) => put(`/api/md/menus/copy/${clientId}`),
    batchDel: (clientId) => del(`/api/md/menus/patch/${clientId}`),
  },
};
export default api;
